import type { MapKit } from '../types/mapkit'

const MAPKIT_JS_URL = 'https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.js'

let pending: Promise<MapKit> | null = null

export function loadMapKit(): Promise<MapKit> {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('mapkit: window is not available'))
  }
  if (window.mapkit) {
    return Promise.resolve(window.mapkit)
  }
  if (pending) {
    return pending
  }
  pending = new Promise<MapKit>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${MAPKIT_JS_URL}"]`)
    const script = existing ?? document.createElement('script')
    const onLoad = (): void => {
      if (window.mapkit) {
        resolve(window.mapkit)
      } else {
        reject(new Error('mapkit: script loaded but window.mapkit is undefined'))
      }
    }
    const onError = (): void => {
      pending = null
      reject(new Error('mapkit: failed to load script'))
    }
    script.addEventListener('load', onLoad, { once: true })
    script.addEventListener('error', onError, { once: true })
    if (!existing) {
      script.src = MAPKIT_JS_URL
      script.crossOrigin = 'anonymous'
      script.async = true
      document.head.appendChild(script)
    }
  })
  return pending
}

export function __resetLoadMapKitForTests(): void {
  pending = null
}
